import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";
import History from "../views/History";
import News from "../views/News";
import Gallery from "../views/Gallery";
import AboutUs from "../views/AboutUs";
import Documents from "../views/Documents";
import Contact from "../views/Contact";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "homepage",
    component: Home
  },
  {
      path: "/history",
      name: "history",
      component: History
  },
  {
    path: "/news",
    name: "news",
    component: News
},
  {
      name: "gallery",
      path: "/gallery",
      component: Gallery,
      children: [
        {
          name: 'galleryType',
          path: ':galleryType',
          children: [
            {
              name: "galleryYear",
              path: ":year",
              children: [
                {
                  name: "galleryInstance",
                  path: ":gallery"
                }
              ]
            }
          ]
        }
      ]
  },
  {
      path: "/about_us",
      name: "about_us",
      component: AboutUs
  },
  {
      path: "/documents",
      name: "documents",
      component: Documents
  },
  {
      path: "/contact",
      name: "contact",
      component: Contact
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
